//
// locale_hr.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/hr.json';
import localeData from "react-intl/locale-data/hr.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
